import { RestrictionName } from "@safetyculture/s12-apis-connect-web/s12/restrictions/v1/common_pb";

// Friendly labels for the "Restriction" column on the Restrictions tab
// (restrictions-tab.tsx). Hand-authored for readability from the
// RESTRICTION_NAME_* enum in @safetyculture/s12-apis-connect-web, which has no
// display-name field of its own - not sourced from an approved style guide,
// so confirm wording with the owning team before treating it as authoritative
// copy. Only covers names already surfaced in this codebase; any name missing
// here falls back to the raw enum name (see restrictions-tab.tsx).
//
// Keyed by a template-literal type over the enum's own member names, so a
// typo'd or stale (e.g. renamed) key fails the build instead of silently
// falling back to the raw name at runtime.
export type RestrictionNameKey =
  `RESTRICTION_NAME_${keyof typeof RestrictionName}`;

export const RESTRICTION_DISPLAY_NAMES: Readonly<
  Partial<Record<RestrictionNameKey, string>>
> = {
  RESTRICTION_NAME_AI_CREDIT_USAGE: "AI Credit Usage",
  RESTRICTION_NAME_ANALYTICS_APPLY_DATE_FILTER_LIMIT:
    "Analytics Date Filter Limit",
  RESTRICTION_NAME_ATTENDANCE_FEATURE_GATE: "Attendance Feature Gate",
  RESTRICTION_NAME_ATTENDANCE_SITE_LIMIT: "Attendance Site Limit",
  RESTRICTION_NAME_AUDIT_HISTORY_ACCESS: "Audit History Access",
  RESTRICTION_NAME_AUDIT_HISTORY_RETENTION_LIMIT:
    "Audit History Retention Limit",
  RESTRICTION_NAME_CONSTRUCTION_FEATURE_GATE: "Construction Feature Gate",
  RESTRICTION_NAME_CREATE_GROUP: "Create Group",
  RESTRICTION_NAME_DELEGATED_MANAGEMENT_FEATURE_GATE:
    "Delegated Management Feature Gate",
  RESTRICTION_NAME_GROUPS_CREATE_DYNAMIC_GROUP: "Create Dynamic Group",
  RESTRICTION_NAME_HOME_CUSTOM_LAYOUT: "Home Custom Layout",
  RESTRICTION_NAME_INSPECTION_LIMIT: "Inspection Limit",
  RESTRICTION_NAME_NAVIGATION_ORG_MANAGED: "Org-Managed Navigation",
  RESTRICTION_NAME_NOTIFICATIONS_LOCK_SETTINGS: "Lock Notification Settings",
  RESTRICTION_NAME_SCIM_FEATURE_GATE: "SCIM Feature Gate",
  RESTRICTION_NAME_SITES_MANAGE_RULES: "Manage Site Rules",
  RESTRICTION_NAME_SUBSCRIPTIONS_LIMIT_PREMIUM_TRIALS:
    "Premium Trial Subscriptions Limit",
  RESTRICTION_NAME_TEMPLATE_LIMIT: "Template Limit",
};
